import { Keyboard } from "react-native";

import {
  addBackgroundListener,
  addForegroundListener,
} from "../services/epox/services";
import { apiStore, authStore } from "../services";

let backgroundTime = 0;

// BACKGROUND
function handleBackground() {
  backgroundTime = new Date().getTime();

  Keyboard.dismiss();
}

addBackgroundListener(handleBackground);

// FOREGROUND
const STALE_TIME = 20 * 1000; // 20s

async function handleForeground() {
  const foregroundTime = new Date().getTime();

  const isRecent = foregroundTime - backgroundTime < STALE_TIME;

  if (!isRecent) {
    const state = authStore.getState();

    if (state.token) {
      apiStore.invalidateQueries();
    }
  }
}

addForegroundListener(handleForeground);
